import { Component, OnInit } from '@angular/core';
import { Company } from '../../models/company.model';
import { CompanyMockService } from '../../services/company-mock.service';

@Component({
  selector: 'bwc-new-companies',
  templateUrl: './new-companies.component.html',
  styleUrls: ['./new-companies.component.scss'],
})
export class NewCompaniesComponent implements OnInit {
  companies: Company[] = [];
  followedIds: number[] = [];

  constructor(private companyService: CompanyMockService) {}

  ngOnInit(): void {
    this.companyService.getNewCompanies().subscribe(c => (this.companies = c));
    this.followedIds = this.companyService.getFollowedIds();
  }

  isFollowed(id: number): boolean {
    return this.followedIds.includes(id);
  }

  toggleFollow(company: Company): void {
    const followed = this.companyService.toggleFollowCompany(company);
    this.followedIds = followed
      ? [...this.followedIds, company.id]
      : this.followedIds.filter(id => id !== company.id);
  }
}
